export default {
  namespaced: true,
  state: {
    showModalWithdrawal: false,
    showModalDeposit: false,
    showModalCreateUser: false
  },
  mutations: {
    SHOW_MODAL_WITHDRAWAL(state) {
      state.showModalWithdrawal = true;
    },
    HIDE_MODAL_WITHDRAWAL(state) {
      state.showModalWithdrawal = false;
    },
    SHOW_MODAL_DEPOSIT(state) {
      state.showModalDeposit = true;
    },
    HIDE_MODAL_DEPOSIT(state) {
      state.showModalDeposit = false;
    },
    SHOW_MODAL_CREATE_USER(state) {
      state.showModalCreateUser = true;
    },
    HIDE_MODAL_CREATE_USER(state) {
      state.showModalCreateUser = false;
    }

  },
  actions: {
    showModalWithdrawal({ commit }) {
      commit('SHOW_MODAL_WITHDRAWAL');
    },
    hideModalWithdrwal({ commit }) {
      commit('HIDE_MODAL_WITHDRAWAL');
    },
    showModalDeposit({ commit }) {
      commit('SHOW_MODAL_DEPOSIT');
    },
    hideModalDeposit({ commit }) {
      commit('HIDE_MODAL_DEPOSIT');
    },
    showModalCreateUser({ commit }) {
      commit('SHOW_MODAL_CREATE_USER');
    },
    hideModalCreateUser({ commit }) {
      commit('HIDE_MODAL_CREATE_USER');
    }
  },
  getters: {
    isShowingModalWithdrawal: (state) => state.showModalWithdrawal,
    isShowingModalDeposit: (state) => state.showModalDeposit,
    isShowingModalCreateUser: (state) => state.showModalCreateUser,
  },
};
